// extracted by mini-css-extract-plugin
export default {"form":"LoginRegister_form__q0HrZ","checkbox":"LoginRegister_checkbox__+VE3a","btns":"LoginRegister_btns__rVtJj","boxes":"LoginRegister_boxes__OyG3X"};